import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const ExcelFileImage = (t0)=>{
    const $ = c(14);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M13.0013 12.2545C13.0013 8.24793 16.2492 5 20.2557 5H45.3728C47.3761 5 49 6.62396 49 8.62723V47.3728C49 49.376 47.3761 51 45.3728 51H20.2557C16.2492 51 13.0013 47.7521 13.0013 43.7455V12.2545Z",
            fill: "url(#paint0_linear_17004_4090)"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M12.9955 20.332H34.6205C32.6177 20.3325 30.9927 21.9561 30.9926 23.959V32.2305C30.8016 34.0605 29.255 35.4873 27.3744 35.4873H30.9926V35.5127H12.9936V15.1963H12.9955V20.332Z",
            fill: "url(#paint1_linear_17004_4090)"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M45.3705 5C47.3736 5.00011 48.9973 6.62389 48.9974 8.62695V16.7061C48.9974 18.7092 47.3736 20.3329 45.3705 20.333H20.2133C16.224 20.3532 12.9955 23.5929 12.9955 27.5869L12.9955 20.332H12.9984V12.2549C12.9984 8.24836 16.2468 5 20.2533 5H45.3705Z",
            fill: "url(#paint2_linear_17004_4090)"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M30.9974 8.62722C30.9974 6.62396 32.6213 5 34.6246 5H45.3705C47.3736 5.00011 48.9973 6.62389 48.9974 8.62695V16.7061C48.9974 18.7093 47.3728 20.3333 45.3695 20.3333H34.6246C32.6213 20.3333 30.9974 18.7094 30.9974 16.7061V8.62722Z",
            fill: "url(#paint3_linear_17004_4090)"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M7 32.7007C7 30.6974 8.62396 29.0734 10.6272 29.0734H21.3722C23.3754 29.0734 24.9994 30.6974 24.9994 32.7007V43.8462C24.9994 45.8495 23.3754 47.4734 21.3722 47.4734H10.6272C8.62396 47.4734 7 45.8495 7 43.8462V32.7007Z",
            fill: "url(#paint4_linear_17004_4090)"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M13.9787 33.6801L15.8406 36.8269H15.9128L17.7837 33.6801H19.9882L17.1706 38.2966L20.0514 42.9131H17.8062L15.9128 39.7618H15.8406L13.9472 42.9131H11.7111L14.6009 38.2966L11.7652 33.6801H13.9787Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint0_linear_17004_4090",
            x1: "28.1508",
            y1: "28",
            x2: "47.2748",
            y2: "48.5108",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#175D1F"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#348C36"
                })
            ]
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint1_linear_17004_4090",
            x1: "30.3401",
            y1: "25.4571",
            x2: "15.0244",
            y2: "26.5534",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#47A245"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#4CB95E"
                })
            ]
        });
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint2_linear_17004_4090",
            x1: "14.7206",
            y1: "16.2935",
            x2: "48.9974",
            y2: "16.2935",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#BDE487"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.250541",
                    stopColor: "#76DB61"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.519777",
                    stopColor: "#56BB42"
                })
            ]
        });
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint3_linear_17004_4090",
            x1: "32.1223",
            y1: "8.22",
            x2: "49.2403",
            y2: "19.9789",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#B7EA74"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#79E96B"
                })
            ]
        });
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t7,
                t8,
                t9,
                t10,
                /*#__PURE__*/ jsxs("linearGradient", {
                    id: "paint4_linear_17004_4090",
                    x1: "7",
                    y1: "29.0732",
                    x2: "25.3955",
                    y2: "47.0683",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            stopColor: "#2FA762"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "1",
                            stopColor: "#0C5132"
                        })
                    ]
                })
            ]
        });
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== height || $[12] !== width) {
        t12 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t11
            ]
        });
        $[11] = height;
        $[12] = width;
        $[13] = t12;
    } else t12 = $[13];
    return t12;
};
export { ExcelFileImage };
